export const interns = [
    {
        id: 'bank-0',
        name: 'ВТБ Юниор в головной организации',
        applying: 'Весна - лето 2025',
        start: 'Июль 2025',
        duration: '12 месяцев',
        placement: 'Москва, Санкт-Петербург, Самара',
        type: 'Оплачиваемая',
        directions: ['Розничный бизнес', 'Средний и малый бизнес', 'Корпоративно-инвестиционный бизнес', 'Технологический блок', 'Поддержка и контроль']
    },
    {
        id: 'bank-1',
        name: 'ВТБ Юниор для сети банка',
        applying: 'Весна - лето 2025',
        start: 'Лето 2025',
        duration: '12 месяцев',
        placement: 'Москва и более 70 городов РФ',
        type: 'Оплачиваемая',
        directions: ['Розничный бизнес', 'Средний и малый бизнес']
    },
    {
        id: 'bank-2',
        name: 'ВТБ РОСТ',
        applying: 'Весна - лето 2025',
        start: 'Сентябрь 2025',
        duration: '12 месяцев',
        placement: 'Москва, Санкт-Петербург',
        type: 'Оплачиваемая',
        directions: ['Розничный бизнес', 'Корпоративно-инвестиционный бизнес', 'Технологический блок', 'Поддержка и контроль']
    },
    {
        id: 'it-0',
        name: 'IT Юниор',
        applying: 'Лето 2025',
        start: 'Осень 2025',
        duration: '6 месяцев',
        placement: 'Москва и Самара',
        type: 'Оплачиваемая',
    },
    {
        id: 'it-1',
        name: 'IT Школы',
        applying: 'Весна - лето 2025',
        start: 'Лето - осень 2025',
        duration: '3 месяца',
        placement: 'Москва',
        type: 'Оплачиваемая',
    },
]; 
